import { ConfirmSignUpPage } from "../components"

export default ConfirmSignUpPage
